import React, { useEffect, useRef, useState } from 'react'
import API from '../../utils/api'
import { getCurrentTeamData } from '../../utils/team-data'
import Modal from 'react-bootstrap/Modal'
import { navigate } from '../../utils/navigate'
import { parseNotificationCount, sortNotificationsNewestFirst } from '../../utils/notifications'

const POLL_MS = 60000

const readStoredNotifications = () => {
  const stored = localStorage.getItem(`notifications`)
  if (!stored) return []
  try {
    return sortNotificationsNewestFirst(JSON.parse(stored))
  } catch (error) {
    return []
  }
}

const SvgNotification = () => {
  const teamData = getCurrentTeamData() || {}
  const notificationCountRef = useRef(parseNotificationCount(localStorage.getItem(`notificationsCount`)))
  const [showNewNotifications, setShowNewNotifications] = useState(() => Boolean(localStorage.getItem(`notificationsUpdated`)))
  const [latestNotification, setLatestNotification] = useState(() => readStoredNotifications()[0] || null)
  const [showModal, setShowModal] = useState(false)

  const handleModalClose = () => {
    setShowModal(false)
    setShowNewNotifications(false)
    localStorage.setItem(`notificationsUpdated`, ``)
    localStorage.setItem(`notificationsModal`, ``)
  }

  const handleModalCloseReadLater = () => {
    setShowModal(false)
    localStorage.setItem(`notificationsModal`, ``)
  }

  const handleIconClick = () => {
    setShowModal(false)
    setShowNewNotifications(false)
    localStorage.setItem(`notificationsUpdated`, ``)
    navigate(`/notifications/`)
  }

  useEffect(() => {
    const huntId = teamData.hunt_id
    if (huntId === undefined) return undefined

    let cancelled = false

    const checkForNotifications = () => {
      API.get(`/hunt/${huntId}/notifications/`, {
        headers: {},
      })
        .then(res => {
          if (cancelled) return
          const count = parseNotificationCount(res.data.results.count)
          if (count <= notificationCountRef.current) return

          const newestFirst = sortNotificationsNewestFirst(res.data.results.notifications)
          localStorage.setItem(`notifications`, JSON.stringify(newestFirst))
          localStorage.setItem(`notificationsCount`, JSON.stringify(count))
          localStorage.setItem(`notificationsUpdated`, true)
          localStorage.setItem(`notificationsModal`, true)
          notificationCountRef.current = count
          setShowNewNotifications(true)
          setLatestNotification(newestFirst[0] || null)
          setShowModal(true)
          window.dispatchEvent(new CustomEvent(`notifications-updated`))
        })
        .catch(() => {})
    }

    checkForNotifications()
    const interval = setInterval(checkForNotifications, POLL_MS)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [teamData.hunt_id])

  return (
    <>
      <span
        className="btn btn-link menu-toggle"
        onClick={handleIconClick}
        style={{
          cursor: `pointer`,
        }}>
        <span className={showNewNotifications ? `notification-icon notification-icon--new` : `notification-icon`}>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 80 96">
            <path
              fill="#FFF"
              stroke="#F5F2ED"
              strokeWidth={1}
              d="M75.727 65.543a6.026 6.026 0 0 1-2.07-4.547v-26.84c0-9-3.5-17.453-9.86-23.797C57.286 3.848 48.617.351 39.415.504 21.18.816 6.345 16.23 6.345 34.867v26.129a6.036 6.036 0 0 1-2.067 4.547A10.552 10.552 0 0 0 .657 73.5c0 4.613 3.754 8.367 8.367 8.367H29.22v2.851C29.22 90.664 34.055 95.5 40 95.5s10.781-4.835 10.781-10.78v-2.852h20.195c4.614 0 8.367-3.754 8.367-8.367 0-3.055-1.32-5.953-3.617-7.957h.001ZM46.258 84.72A6.267 6.267 0 0 1 40 90.977a6.264 6.264 0 0 1-6.257-6.258v-2.851h12.52l-.005 2.851Zm24.72-7.375H9.023A3.849 3.849 0 0 1 5.18 73.5c0-1.742.754-3.402 2.07-4.547a10.552 10.552 0 0 0 3.622-7.957l-.004-26.129c0-16.184 12.84-29.57 28.625-29.836.172-.003.344-.003.512-.003 7.78 0 15.078 3.02 20.594 8.535 5.504 5.492 8.53 12.805 8.53 20.598V61c0 3.05 1.321 5.953 3.622 7.957a6.026 6.026 0 0 1 2.07 4.547 3.848 3.848 0 0 1-3.844 3.84Z"
            />
          </svg>
        </span>
      </span>

      <Modal show={showModal} onHide={handleModalCloseReadLater} centered scrollable={true} aria-labelledby="send-notification">
        <Modal.Header className={`card-header`} closeButton>
          <Modal.Title id="progress-modal-title" className={`card-title mb-2`}>
            {latestNotification && latestNotification.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`card-body bg-white text-dark`}>
          {latestNotification && latestNotification.message}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className={`btn btn-block btn-tiny mt-4`} onClick={handleModalClose}>
            Mark As Read
          </button>

          <button type="button" className={`btn btn-block btn-tiny mt-4`} onClick={handleModalCloseReadLater}>
            Read Later
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SvgNotification
